<script lang="ts" module>
	export const symbolId = "ishavskraft-icon-home";
	export const symbol = `
		<symbol id="${symbolId}" viewBox="0 0 45 45">
			<path
				d="M3.75 29.0625H9.375V19.6875C9.375 19.1563 9.555 18.7113 9.915 18.3525C10.275 17.9938 10.72 17.8137 11.25 17.8125H18.75C19.2812 17.8125 19.7269 17.9925 20.0869 18.3525C20.4469 18.7125 20.6262 19.1575 20.625 19.6875V29.0625H26.25V12.1875L15 3.75L3.75 12.1875V29.0625ZM0 29.0625V12.1875C0 11.5938 0.133125 11.0313 0.399375 10.5C0.665625 9.96875 1.0325 9.53125 1.5 9.1875L12.75 0.75C13.4063 0.25 14.1563 0 15 0C15.8437 0 16.5937 0.25 17.25 0.75L28.5 9.1875C28.9688 9.53125 29.3363 9.96875 29.6025 10.5C29.8688 11.0313 30.0012 11.5938 30 12.1875V29.0625C30 30.0938 29.6325 30.9769 28.8975 31.7119C28.1625 32.4469 27.28 32.8137 26.25 32.8125H18.75C18.2188 32.8125 17.7738 32.6325 17.415 32.2725C17.0563 31.9125 16.8762 31.4675 16.875 30.9375V21.5625H13.125V30.9375C13.125 31.4687 12.945 31.9144 12.585 32.2744C12.225 32.6344 11.78 32.8137 11.25 32.8125H3.75C2.71875 32.8125 1.83625 32.4456 1.1025 31.7119C0.36875 30.9781 0.00125 30.095 0 29.0625Z"
				fill="currentColor"
			/>
		</symbol>`;
</script>

<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	let {
		class: classes = null,
		ariaHidden = true,
	}: {
		class?: ClassValue | null;
		ariaHidden?: boolean;
	} = $props();
</script>

<svg
	aria-hidden={ariaHidden}
	width="24"
	height="24"
	viewBox="0 0 45 45"
	xmlns="http://www.w3.org/2000/svg"
	class={classes}
	fill="currentColor"
>
	<use href="#{symbolId}" />
</svg>
